export default __webpack_public_path__ + "static/media/transactional-state.0d9ded56.svg";